"use client";

import { IconArrowNarrowRight } from "@tabler/icons-react";
import PrzesiadkaBanerDesktopHp from "@/assets/images/przesiadka/przesiadka-baner-desktop-hp.png";
import PrzesiadkaBanerDesktop from "@/assets/images/przesiadka/przesiadka-baner-desktop-new.png";
import PrzesiadkaBanerMobile from "@/assets/images/przesiadka/przesiadka-baner-mobile-new.png";
import { Img } from "@/components/image";
import { buttonVariants } from "@/components/ui/button";
import type { BurnBannerType } from "@/features/static-builder/types/burn-banner.type";
import { Link } from "@/i18n/navigation";
import { interpretColors } from "@/lib/helpers/typography";
import { cn } from "@/lib/utils";

export const BurnBanner = ({
  data,
  listing,
}: {
  data: BurnBannerType;
  listing?: boolean;
}) => {
  const isMobile =
    typeof window !== "undefined" ? window.innerWidth < 768 : false;
  return (
    <section
      className={cn(listing ? "h-full p-0" : "container py-10 lg:py-20")}
    >
      <div
        className={cn(
          "relative flex w-full items-center rounded-lg bg-brand-green2-300",
          listing ? "h-full overflow-hidden" : "h-[170px] md:h-60",
        )}
      >
        <div
          className={cn(
            "z-10 w-full space-y-4 pl-4 md:space-y-6 md:pl-8",
            listing && "md:py-12",
          )}
        >
          {listing ? (
            <div>
              <h2 className="w-2/4 font-medium text-2xl text-brand-white leading-8 md:w-3/4 md:text-5xl md:leading-heading">
                {data.title}
              </h2>
              <p
                className="font-medium text-brand-white text-lg leading-6 max-sm:w-2/4 max-md:mt-1.5 md:text-xl"
                dangerouslySetInnerHTML={{
                  __html: isMobile
                    ? interpretColors(data.description || "").slice(7)
                    : interpretColors(data.description || ""),
                }}
              />
            </div>
          ) : (
            <>
              <h2 className="mb-2 w-2/3 font-medium text-2xl text-brand-white leading-8 md:w-3/4 md:text-5xl md:leading-heading">
                {data.title}
              </h2>
              <p
                className="hidden font-medium text-brand-white text-lg md:block md:text-xl"
                dangerouslySetInnerHTML={{
                  __html: isMobile
                    ? interpretColors(data.description || "").slice(7)
                    : interpretColors(data.description || ""),
                }}
              />
            </>
          )}
          <Link
            className={cn(
              buttonVariants({ variant: "secondary", size: "default" }),
              "text-brand-green2-300 max-md:px-3 max-md:py-2",
            )}
            href={data.url}
            rel="noopener noreferrer"
            target="_blank"
          >
            {data.linkLabel}
            <IconArrowNarrowRight className="h-6 w-6" stroke={1.25} />
          </Link>
        </div>
        <div
          className={cn(
            "absolute z-0 h-full overflow-hidden rounded-r-lg",
            listing && isMobile ? "top-0 right-0" : "top-0 right-0",
          )}
        >
          {isMobile ? (
            <Img
              alt="Przesiadka baner mobile"
              className="h-full w-auto object-cover"
              src={PrzesiadkaBanerMobile}
            />
          ) : listing ? (
            <Img
              alt="Przesiadka baner desktop"
              className="h-full w-auto object-cover"
              src={PrzesiadkaBanerDesktop}
            />
          ) : (
            <Img
              alt="Przesiadka baner desktop"
              className="h-full w-auto object-cover"
              src={PrzesiadkaBanerDesktopHp}
            />
          )}
        </div>
      </div>
    </section>
  );
};
